export const DEFAULT_BACKGROUND = "trading-floor";

export const BACKGROUNDS = [
  { id: "none", label: "Plain" },
  { id: "wallstreet", label: "Wall Street Dusk" },
  { id: "trading-floor", label: "Trading Floor" },
  { id: "candlesticks", label: "Candlesticks" },
  { id: "gold-bull", label: "Gold Bull" },
  { id: "world-markets", label: "World Markets" },
  { id: "ticker-tape", label: "Ticker Tape" },
  { id: "vault", label: "The Vault" },
];

export const bgSrc = (id, thumb = false) => (id && id !== "none" ? `/backgrounds/${thumb ? "thumbs/" : ""}${id}.jpg` : null);

export const getStoredBackground = () => {
  try { return localStorage.getItem("rj_background") || DEFAULT_BACKGROUND; } catch { return DEFAULT_BACKGROUND; }
};

export const storeBackground = (id) => {
  try { localStorage.setItem("rj_background", id); } catch {}
};
